export const QUERY_KEY = "organizations";
export const QUERY_KEY_PAYMENT_DETAILS = "organizations/payment-details";
